// import { useState } from "react"
// import { Dialog, DialogContent, DialogHeader } from "../../../components/ui/dialog"
// import { Button } from "../../../components/ui/button"
// import { X, Check, Building2, Grid3x3, Shield } from "lucide-react"
// import { StepIndicator } from "./step-indicator"
// import { SchoolModuleStep } from "./steps/school-module-step"
// import { PromptStep } from "./steps/prompt-step"
// import { PolicyStep } from "./steps/policy-step"
// import { ReviewStep } from "./steps/review-step"


// const STEPS = [
//   { id: 1, label: "Schools & Modules", icon: Building2 },
//   { id: 2, label: "Prompts", icon: Grid3x3 },
//   { id: 3, label: "Policies", icon: Shield },
//   { id: 4, label: "Review", icon: Check },
// ]

// export function UserRightsModal({ isOpen, onClose, userId, userName }) {
//   const [currentStep, setCurrentStep] = useState(1)
//   const [rights, setRights] = useState({
//     schools_id: [],
//     module_ids: [],
//     prompt_category_ids: [],
//     prompt_ids: [],
//     policies_id: [],
//   })

//   const handleNext = () => {
//     if (currentStep < STEPS.length) {
//       setCurrentStep(currentStep + 1)
//     }
//   }

//   const handlePrev = () => {
//     if (currentStep > 1) {
//       setCurrentStep(currentStep - 1)
//     }
//   }

//   const handleStepClick = (step) => {
//     setCurrentStep(step)
//   }

//   const handleSave = () => {
//     console.log("Saving user rights:", { userId, rights })
//     // API call would go here
//     onClose()
//   }

//   const updateRights = (updates) => {
//     setRights((prev) => ({ ...prev, ...updates }))
//   }

//   return (
//     <Dialog open={isOpen} onOpenChange={onClose}>
//       <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto bg-card border border-border">
//         <DialogHeader className="sticky top-0 bg-card border-b border-border pb-4">
//           <div className="flex items-center justify-between">
//             <div>
//               <h2 className="text-2xl font-bold text-foreground">Manage User Permissions</h2>
//               <p className="text-sm text-muted-foreground mt-1">Setting permissions for {userName}</p>
//             </div>
//             <button onClick={onClose} className="text-muted-foreground hover:text-foreground transition-colors">
//               <X className="w-6 h-6" />
//             </button>
//           </div>
//         </DialogHeader>

//         <div className="px-6 py-6">
//           {/* Step Indicator */}
//           <StepIndicator steps={STEPS} currentStep={currentStep} onStepClick={handleStepClick} />

//           {/* Content Area */}
//           <div className="mt-8 min-h-96">
//             {currentStep === 1 && <SchoolModuleStep rights={rights} updateRights={updateRights} />}
//             {currentStep === 2 && <PromptStep rights={rights} updateRights={updateRights} />}
//             {currentStep === 3 && <PolicyStep rights={rights} updateRights={updateRights} />}
//             {currentStep === 4 && <ReviewStep rights={rights} />}
//           </div>

//           {/* Navigation Buttons */}
//           <div className="flex items-center justify-between mt-8 pt-6 border-t border-border">
//             <Button
//               onClick={handlePrev}
//               variant="outline"
//               disabled={currentStep === 1}
//               className="text-foreground border-border hover:bg-muted bg-transparent"
//             >
//               ← Previous
//             </Button>

//             <div className="text-sm text-muted-foreground">
//               Step {currentStep} of {STEPS.length}
//             </div>

//             {currentStep < STEPS.length ? (
//               <Button onClick={handleNext} className="bg-primary hover:bg-primary/90 text-primary-foreground">
//                 Next →
//               </Button>
//             ) : (
//               <Button onClick={handleSave} className="bg-green-600 hover:bg-green-700 text-white">
//                 Save Permissions
//               </Button>
//             )}
//           </div>
//         </div>
//       </DialogContent>
//     </Dialog>
//   )
// }


import { useState } from "react"
import { Modal } from "react-bootstrap"
import { Button } from "../../../../components/ui/button"
import { X, Check, Building2, Grid3x3, Shield } from "lucide-react"

import { StepIndicator } from "./step-indicator"
import { SchoolModuleStep } from "./steps/school-module-step"
import { PromptStep } from "./steps/prompt-step"
import { PolicyStep } from "./steps/policy-step"
import { ReviewStep } from "./steps/review-step"

const STEPS = [
  { id: 1, label: "Schools & Modules", icon: Building2 },
  { id: 2, label: "Prompts", icon: Grid3x3 },
  { id: 3, label: "Policies", icon: Shield },
  { id: 4, label: "Review", icon: Check },
]

const EMPTY_RIGHTS = {
  schools: { create: [], read: [], update: [], delete: [] },
  modules: { create: [], read: [], update: [], delete: [] },
  prompt_categories: { create: [], read: [], update: [], delete: [] },
  prompts: { create: [], read: [], update: [], delete: [] },
}

export function UserRightsModal({ isOpen, onClose, userId, userName }) {
  const [currentStep, setCurrentStep] = useState(1)
    const [rights, setRights] = useState(EMPTY_RIGHTS)
    // const [rights, setRights] = useState({
    //   schools_id: [],
    //   module_ids: [],
    //   prompt_category_ids: [],
    //   prompt_ids: [],
    //   policies_id: [],
    // })

  const handleNext = () => {
    if (currentStep < STEPS.length) setCurrentStep(currentStep + 1)
  }

  const handlePrev = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1)
  }

  const handleStepClick = (step) => setCurrentStep(step)

  const handleSave = () => {
    const output = {
      userId,
      userRights: rights,
    }
    console.log("Saving user rights:", output)
    onClose()
  }

  const updateRights = (updates) => {
    setRights((prev) => ({ ...prev, ...updates }))
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="xl"
      centered
      scrollable
      className="addEditModal"
      contentClassName="bg-card border border-border max-h-[90vh]"
    >
      {/* Header */}
      <Modal.Header closeButton className="border-b border-border bg-card sticky top-0 z-10">
        <Modal.Title>
          <h2 className="text-2xl font-bold text-foreground">Manage User Permissions</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Setting permissions for {userName}
          </p>
        </Modal.Title>
      </Modal.Header>

      {/* Body */}
      <Modal.Body className="px-6 py-6">
        {/* Step Indicator */}
        <StepIndicator
          steps={STEPS}
          currentStep={currentStep}
          onStepClick={handleStepClick}
        />

        {/* Content */}
        <div className="mt-8 min-h-96">
          {currentStep === 1 && <SchoolModuleStep rights={rights} updateRights={updateRights} />}
          {currentStep === 2 && <PromptStep rights={rights} updateRights={updateRights} />}
          {currentStep === 3 && <PolicyStep rights={rights} updateRights={updateRights} />}
          {currentStep === 4 && <ReviewStep rights={rights} />}
        </div>
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer className="border-t border-border flex items-center justify-between">
        <Button
          onClick={handlePrev}
          variant="outline"
          disabled={currentStep === 1}
          className="text-foreground border-border hover:bg-muted bg-transparent"
        >
          ← Previous
        </Button>

        <div className="text-sm text-muted-foreground">
          Step {currentStep} of {STEPS.length}
        </div>

        {currentStep < STEPS.length ? (
          <Button
            onClick={handleNext}
            className="bg-primary hover:bg-primary/90 text-primary-foreground"
          >
            Next →
          </Button>
        ) : (
          <Button
            onClick={handleSave}
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            Save Permissions
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
